import axios from "axios";
import { log } from "@/plugins/consoleLogger";
import { paymentsUrl } from "../moduleUrls";

export async function createPayment(body) {

  try {
    const res = await axios.post(
      `${paymentsUrl}/payments`,
      body,
      {
        timeout: 30000
      }
    );

    if (res.status === 201) return res.data;
    else {
      throw new Error("Something went wrong with starting the payment!");
    }
  } catch (error) {
    log("error", `Error initiating payment: ${err.toString()}`);
    throw new Error("Error initiating payment");
  }
}

export async function checkPaymentStatus(transactionId) {
  try {
    const res = await axios.post(
      `${paymentsUrl}/payments/status`,
      {
        transactionId
      },
      {
        timeout: 30000
      }
    );
    return res;
  } catch (err) {
    log("error", `Error checking payment status: ${err.toString()}`);
    throw new Error("Error checking payment status");
  }
}

export async function cancelPayment(transaction_id) {
  try {
    const res = await axios.post(
      `${paymentsUrl}/payments/cancel`,
      {
        transaction_id
      },
      {
        timeout: 30000
      }
    );
    return res;
  } catch (err) {
    log("error", `Error cancelling payment: ${err.toString()}`);
    throw new Error("Error cancelling payment");
  }
}
